module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-newsletter",
    attrs: {
      "id": "section-newsletter"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-flex-mobile is-centered"
  }, [_c('div', {
    staticClass: "column is-8 is-11-mobile"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "cont-form cont-form-info",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "value": "",
      "placeholder": "NAME"
    },
    on: {
      "input": function($event) {
        return _vm.$v.name.$touch()
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "cont-form cont-form-message",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "value": "",
      "placeholder": "EMAIL"
    },
    on: {
      "input": function($event) {
        return _vm.$v.email.$touch()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "button submit is-outlined",
    class: {
      'is-loading': _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onSend(_vm.$v)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loading ? ' ' : 'SUBSCRIBE'))])]), _vm._v(" "), (_vm.feedback) ? _c('p', [_vm._v(_vm._s(_vm.feedback))]) : _vm._e()], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-6 has-text-centered"
  }, [_c('div', {
    staticClass: "cont-desc",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": require("../assets/logo.svg"),
      "width": "50"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-6 has-text-centered"
  }, [_c('div', {
    staticClass: "cont-desc",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('h3', {
    staticClass: "title",
    staticStyle: {
      "font-size": "1.8em"
    }
  }, [_vm._v("Mailing List")]), _vm._v(" "), _c('span', [_vm._v("Stay up to date! Never miss an unforgettable 'Live In Concert' experience by InTour Live. Subscribe to receive emails on our next big show.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-600fcbae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NewsletterSection.vue
// module id = 917
// module chunks = 1